import { cn } from "@/lib/utils";
import UserGuide from "@/assets/images/user-guide.png"

type Props = {
  className?: string;
  onClick?: () => void;
};

function BouncingBook({ className, onClick }: Props) {
  return (
    <button
      className={cn(
        className,
        "w-fit rounded-full bg-secondary p-2 float-left animate-bounce mt-6"
      )}
      onClick={onClick}
    >
      <img src={UserGuide} alt="icon" width="44"></img>
    </button>
  );
}

export default BouncingBook;
